// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"349":"686ba05b","395":"b9e2e7ad"}[chunkId] + ".css";
};